import { TranslateService } from '@ngx-translate/core';

export class HttpErrorMessage extends Error {
	key = 'Errors.';
	code: number;
	params = {};
	translated: string = '';
	functional: boolean;
	extraData: any;
	specificError: string;

	constructor(public message: string) {
		super(message);
		// https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
		Object.setPrototypeOf(this, HttpErrorMessage.prototype);
		this.name = 'HttpErrorMessage';
	}

	translate(translateService: TranslateService): HttpErrorMessage {
		this.translated = translateService.instant(this.key, this.params);
		return this;
	}

	fromCode(code: number): HttpErrorMessage {
		this.code = code;
		return this;
	}

	resetKey(key: any): HttpErrorMessage {
		this.key = 'Errors.' + key;
		return this;
	}

	appendKey(key: any): HttpErrorMessage {
		this.key += '' + key;
		return this;
	}

	withParams(params: any): HttpErrorMessage {
		this.params = { ...this.params, ...params };
		return this;
	}

	// backward compatibility
	toString(): string {
		return this.translated || this.key;
	}

	is(test: string | number): boolean {
		return this.code === test || this.key.includes('' + test);
	}

	asFunctional(toggle: boolean = true): HttpErrorMessage {
		this.functional = toggle;
		return this;
	}
}
